<template>
  <base-modal name="deleteRecurringMeeting" width="380">
    <template #body>
      <div class="flex justify-end">
        <close-icon
          @click.native="closeModals('deleteRecurringMeeting')"
          class="mt-15 cursor-pointer"
        />
      </div>
      <div class="px-15">
        <div class="flex mt-20">
          <p class="text-title font-bold">
            {{ $t('delete_recurring_meeting') }}
          </p>
        </div>
        <div class="py-10">
          <base-radio-button
            id="this_meeting_delete"
            value="one"
            name="this_meeting"
            :label="$t('this_meeting')"
            v-model="typeOfMeeting"
            class="py-10"
          />
          <base-radio-button
            id="this_and_following_meetings_delete"
            value="following"
            name="this_and_following_meetings"
            :label="$t('this_and_following_meetings')"
            v-model="typeOfMeeting"
            class="py-10"
          />
          <base-radio-button
            id="all_meetings_delete"
            value="all"
            name="all_meetings"
            :label="$t('all_meetings')"
            v-model="typeOfMeeting"
            class="py-10"
          />
        </div>
        <div class="flex gap-x-10">
          <base-button
            height="48"
            width="167"
            buttonType="cancel"
            radius="default"
            @click.native="cancelButtonHandler()"
          >
            <template #text>
              <span class="text-14 font-bold">
                {{ $t('cancel') }}
              </span>
            </template>
          </base-button>
          <base-button
            height="48"
            width="167"
            buttonType="danger-opacity"
            radius="default"
            @click.native="deleteButtonHandler()"
          >
            <template #text>
              <span class="text-14 font-bold"> {{ $t('delete') }} </span>
            </template>
          </base-button>
        </div>
      </div>
    </template>
  </base-modal>
</template>
<script>
import BaseButton from '@/components/base/BaseButton.vue';
import BaseModal from '@/components/modals/BaseModal.vue';
import CloseIcon from '@/assets/icons/vue/close_normal.vue';
import BaseRadioButton from '@/components/base/BaseRadioButton.vue';

export default {
  name: 'deleteRecurringMeeting',
  components: {
    BaseButton,
    BaseModal,
    CloseIcon,
    BaseRadioButton,
  },
  data() {
    return {
      typeOfMeeting: 'one',
    };
  },
  methods: {
    closeModals(...modals) {
      modals.map((modalName) => this.$store.dispatch('modal/close', modalName));
    },
    cancelButtonHandler() {
      this.closeModals('deleteRecurringMeeting');
    },
    deleteButtonHandler() {
      this.$emit('removeRecurringMeeting', this.typeOfMeeting);
    },
  },
};
</script>
<style scoped></style>
